import { Button, Stack } from "@mui/material";

import { MarkShipmentAsPickedUpModal } from "components/MarkShipmentAsPickedUpModal";
import { carrierHasBookingWriteAccess } from "utils";

import {
  useCarrierShipmentPageContext,
  useDisclosure,
} from "../../../../../../../../hooks";

export function MarkShipmentAsPickedUpButton() {
  const { shipment, onRefresh } = useCarrierShipmentPageContext();
  const {
    isOpen: markShipmentAsPickedUpModalOpen,
    onClose: onCloseMarkShipmentAsPickedUpModal,
    onOpen: onOpenMarkShipmentAsPickedUpModal,
  } = useDisclosure(false);

  if (
    !shipment ||
    !carrierHasBookingWriteAccess(shipment) ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status !== "BOOKED"
  ) {
    return null;
  }

  return (
    <Stack>
      <Button
        color="info"
        onClick={onOpenMarkShipmentAsPickedUpModal}
        variant="outlined"
      >
        Mark Picked Up
      </Button>
      <MarkShipmentAsPickedUpModal
        onModalClose={onCloseMarkShipmentAsPickedUpModal}
        modalOpen={markShipmentAsPickedUpModalOpen}
        shipmentId={shipment.info.id}
        onMarkPickedUpSuccess={onRefresh}
      />
    </Stack>
  );
}
